//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import kpFormPage from './kp-form'
import detailPage from '../list-all-receipt/detail.vue'
import invoiceBeforeInfo from './components/invoice-before-info.vue'
import offlineBilling from './components/offline-billing/billing.vue'

export default {
    components: {kpFormPage,detailPage,invoiceBeforeInfo,offlineBilling},
    props: [],
    data () {
        return {
            tableData: [],
            pgData: {
                orderId: '',
                entName: '',
                invoiceStatus: '',
                payStartDate: '', 
                payEndDate: '',
                bidOpenStartDate:'',
                bidOpenEndDate:'',
                applyStartDate: '',
                applyEndDate: '',
	            invoiceStartDate: '', 
                invoiceEndDate: '',
            },
            invoiceInfoDialog:false,
            dialogVisible: false,
            kpDialogVisible:false,
            offlineBillingDialog:false,
            dialogType:'',
            dialogTitle: '',

            linkguid:'',
            orderid:'',
            pgExtra:{},
            applyStatusList:[
                {value:'未申请',key:'0',type:'info'},
                {value:'已申请',key:'1',type:'success'},
            ],
            invoiceStatusList:[
                {value:'未开票',key:'0',type:'info'},
                {value:'已开票',key:'1',type:'success'},
            ],
            infoForm:{},
            invoiceInfo:{},
            isCompleteInfo:false,//是否补全信息
        }
    },
    computed: {
        tableHeight() {
            if(this.zdkp){
                return window.innerHeight - 244 + 'px';
            }else{

                return window.innerHeight - 236 + 'px';
            }
        },
        payDate:{
            get:function(){
                var startTime = this.pgData.payStartDate || '';
                var endtime = this.pgData.payEndDate || '';
                    if(startTime && endtime){
                        return[
                            startTime,
                            endtime
                        ];
                    }else{
                        return[]
                    }
            },
            set:function(val){
                if(!val){
                    this.pgData.payStartDate = '' ;
                    this.pgData.payEndDate = '';
                }else{
                    var startTime = val[0] || '';
                    var endtime = val[1] || '';
                    this.pgData.payStartDate = startTime;
                    this.pgData.payEndDate = endtime;
                }
            },
        },
        bidOpenDate:{
            get:function(){
                var startTime = this.pgData.bidOpenStartDate || '';
                var endtime = this.pgData.bidOpenEndDate || '';
                    if(startTime && endtime){
                        return[
                            startTime,
                            endtime
                        ];
                    }else{
                        return[]
                    }
            },
            set:function(val){
                if(!val){
                    this.pgData.bidOpenStartDate = '' ;
                    this.pgData.bidOpenEndDate = '';
                }else{
                    var startTime = val[0] || '';
                    var endtime = val[1] || '';
                    this.pgData.bidOpenStartDate = startTime;
                    this.pgData.bidOpenEndDate = endtime;
                }
            },
        },
        applyDate:{
            get:function(){
                var startTime = this.pgData.applyStartDate || '';
                var endtime = this.pgData.applyEndDate || '';
                    if(startTime && endtime){
                        return[
                            startTime,
                            endtime
                        ];
                    }else{
                        return[]
                    }
            },
            set:function(val){
                if(!val){
                    this.pgData.applyStartDate = '' ;
                    this.pgData.applyEndDate = '';
                }else{
                    var startTime = val[0] || '';
                    var endtime = val[1] || '';
                    this.pgData.applyStartDate = startTime;
                    this.pgData.applyEndDate = endtime;
                }
            },
        },
        invoiceDate:{
            get:function(){
                var startTime = this.pgData.invoiceStartDate || '';
                var endtime = this.pgData.invoiceEndDate || '';
                    if(startTime && endtime){
                        return[
                            startTime,
                            endtime
                        ];
                    }else{
                        return[]
                    }
            },
            set:function(val){
                if(!val){
                    this.pgData.invoiceStartDate = '' ;
                    this.pgData.invoiceEndDate = '';
                }else{
                    var startTime = val[0] || '';
                    var endtime = val[1] || '';
                    this.pgData.invoiceStartDate = startTime;
                    this.pgData.invoiceEndDate = endtime;
                }
            },
        },
        zdkp:function(){
            return JSON.parse(window.sessionStorage.getItem('isDzfp'))
        }
    },
    watch: {
        dialogVisible(n, o) {
            !n && this.reloadHandler();
        },
        kpDialogVisible(n, o) {
            !n && this.reloadHandler();
        },
        offlineBillingDialog(n, o) {
            !n && this.doSearch();
        },
        
    },
    methods: {
        doSearch:function(){
            this.$refs.page.queryData();
        },
        reloadHandler() {
            this.$refs.page.reload();
        },
        formPageClose:function(){
            this.dialogVisible=false;
            // this.$refs.page.reload();
        },
        kpClose:function(){
            this.kpDialogVisible=false;
            // this.$refs.page.reload();
        },
        invoiceInfoClose(){
            this.invoiceInfoDialog = false;
        },

        //手动开票
        receiptMail(row) {
            if(row.applyStatus == 0 && row.invoiceStatus == 0 && !row.rowguid){
                let newform = clone(row);
                newform.kptype = 'sdkp';
                this.infoForm = newform;
                this.dialogTitle = '开票信息';
                this.isCompleteInfo = false;
                this.invoiceInfoDialog = true;
            }else{
                this.invoiceInfo = row;
                this.linkguid = row.rowguid;
                this.orderid = row.orderId;
                this.dialogTitle = '手动开票'
                this.kpDialogVisible = true;
            }
        },
        //自动开票
        autoKp(row) {
            let that = this;
            if(row.applyStatus == 0 && row.invoiceStatus == 0 && !row.rowguid){
                let newform = clone(row);
                newform.kptype = 'zdkp';
                that.infoForm = newform;
                that.dialogTitle = '开票信息';
                that.isCompleteInfo = false;
                that.invoiceInfoDialog = true;
            }else{
                that.$post(that.getStore('finUrl') + '/receipt/dzfpInit', {
                    rowguid:row.rowguid,
                    orderId:row.orderId,
                    entName:row.entName,
                    entCode:row.entCode,
                    entAddress:row.entAddress,
                    entPhone:row.entPhone,
                    entBankName:row.entBankName,
                    entBankCode:row.entBankCode,
                }, data => {
                    that.$post(that.getStore('finUrl') + '/receipt/dzfp', {
                        rowguid:row.rowguid,
                        orderId:row.orderId,
                        entName:row.entName,
                        entCode:row.entCode,
                        entAddress:row.entAddress,
                        entPhone:row.entPhone,
                        entBankName:row.entBankName,
                        entBankCode:row.entBankCode,
                    }, data => {
                        that.linkguid = data.rowguid;
                        that.dialogVisible = true;
                    });
                })
            }

        },
        getsinvoiceinfo:function(e){
            let that = this;
            that.invoiceInfo = e;
            if(e.kptype == 'sdkp'){
                that.linkguid = e.rowguid;
                that.orderid = e.orderId;
                that.dialogTitle = '手动开票';
                that.kpDialogVisible = true;
            }else if (e.kptype == 'zdkp'){
                that.$post(that.getStore('finUrl') + '/receipt/dzfpInit', {
                    rowguid:e.rowguid,
                    orderId:e.orderId,
                    entName:e.entName,
                    entCode:e.entCode,
                    entAddress:e.entAddress,
                    entPhone:e.entPhone,
                    entBankName:e.entBankName,
                    entBankCode:e.entBankCode,
                }, data => {
                    that.$post(that.getStore('finUrl') + '/receipt/dzfp', {
                        rowguid:e.rowguid,
                        orderId:e.orderId,
                        entName:e.entName,
                        entCode:e.entCode,
                        entAddress:e.entAddress,
                        entPhone:e.entPhone,
                        entBankName:e.entBankName,
                        entBankCode:e.entBankCode,
                    }, data => {
                        that.linkguid = data.rowguid;
                        that.dialogVisible = true;
                    });
                })
            }
        },
        //补全信息
        completeInfo:function(row){
            let newform = clone(row);
            this.infoForm = newform;
            this.isCompleteInfo = true;
            this.invoiceInfoDialog = true;
        },
        getCompleteInfo:function(){
            this.invoiceInfoDialog = false;
            this.reloadHandler();
        },
        afterQuery(data) {
            data.forEach((item) => {
                item.addtime = timeToDate(item.addtime)
                if(item.list) {
                    item.list.forEach((row) => {
                        row.kbtime = timeToDate(row.kbtime)
                        row.latestguaranteeuptime = timeToDate(row.latestguaranteeuptime)
                    })
                }
            })
        },
        downloadHandler() {
            var search = toSearch({
                orderId: this.pgData.orderId,
                entName: this.pgData.entName,
                applyStatus: this.pgData.applyStatus,
                invoiceStatus: this.pgData.invoiceStatus,
                payStartDate: this.pgData.payStartDate,
                payEndDate: this.pgData.payEndDate,
                bidOpenStartDate: this.pgData.bidOpenStartDate,
                bidOpenEndDate: this.pgData.bidOpenEndDate,
                applyStartDate: this.pgData.applyStartDate,
                applyEndDate: this.pgData.applyEndDate,
                invoiceStartDate: this.pgData.invoiceStartDate,
                invoiceEndDate: this.pgData.invoiceEndDate,
                isExport: true
            });
            downloader(this.getStore('finUrl') + '/receipt/list' + search);
        },
        //筛选状态
        filterDiyData:function(arr,val){
            let status =  arr.filter(function(item){
                return item.key == val ;
            })
            if(status.length != 0){
                return status[0]; //返回筛选的对象
            } else{
                return {};
            }
        },
        //离线开票
        offLineBilling:function(){
            this.dialogTitle = '离线开票';
            this.offlineBillingDialog = true;
        },
    },
    mounted: function() {
    }
}
